import { render, staticRenderFns } from "./AddShowcaseModal.vue?vue&type=template&id=03f23560&"
import script from "./AddShowcaseModal.vue?vue&type=script&lang=js&"
export * from "./AddShowcaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports